module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "new-whitelist"
    }
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('span', [_vm._v("清场白名单 > 新增")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('div', {
    staticClass: "whitelist-content"
  }, [_c('el-form', {
    ref: "clearanceForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.clearanceForm,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    staticClass: "white-form",
    staticStyle: {
      "margin-bottom": "18px"
    },
    attrs: {
      "label": "类型：",
      "prop": "type",
      "required": ""
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.clearanceForm.type),
      callback: function($$v) {
        _vm.$set(_vm.clearanceForm, "type", $$v)
      },
      expression: "clearanceForm.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "模拟app",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "中病毒",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运行在虚拟环境",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "white-form",
    staticStyle: {
      "margin-bottom": "18px"
    },
    attrs: {
      "label": "手机号：",
      "prop": "phoneNumber",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.clearanceForm.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.clearanceForm, "phoneNumber", $$v)
      },
      expression: "clearanceForm.phoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "18px"
    },
    attrs: {
      "label": "手机imei：",
      "prop": "imei",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机imei"
    },
    model: {
      value: (_vm.clearanceForm.imei),
      callback: function($$v) {
        _vm.$set(_vm.clearanceForm, "imei", $$v)
      },
      expression: "clearanceForm.imei"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "18px"
    },
    attrs: {
      "label": "手机型号：",
      "prop": "phoneModel",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机型号"
    },
    model: {
      value: (_vm.clearanceForm.phoneModel),
      callback: function($$v) {
        _vm.$set(_vm.clearanceForm, "phoneModel", $$v)
      },
      expression: "clearanceForm.phoneModel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "18px"
    },
    attrs: {
      "label": "系统版本：",
      "prop": "systemVersion",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入系统版本"
    },
    model: {
      value: (_vm.clearanceForm.systemVersion),
      callback: function($$v) {
        _vm.$set(_vm.clearanceForm, "systemVersion", $$v)
      },
      expression: "clearanceForm.systemVersion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "是否root：",
      "prop": "root",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.clearanceForm.root),
      callback: function($$v) {
        _vm.$set(_vm.clearanceForm, "root", $$v)
      },
      expression: "clearanceForm.root"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.clearanceForm.root),
      callback: function($$v) {
        _vm.$set(_vm.clearanceForm, "root", $$v)
      },
      expression: "clearanceForm.root"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "right",
    attrs: {
      "label": "图片：",
      "prop": "imageUrl",
      "required": ""
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或\n                        "), _c('em', [_vm._v("点击上传")])])])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3cabc374!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/whitelist/newWhiteList.vue
// module id = 995
// module chunks = 0